<script>

// Licensed under Gnu Public Licence version 2
// Copyright (c) 2020 (original work) Open Assessment Technologies SA ;
// Auto generated content

export let attributes = {};
</script>
<rtc  {...attributes} ><slot /></rtc>